/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import React, {Fragment, useEffect} from 'react';

import './TransactionHistoryFiltersV2.scss';
import {AAMBeaconControl} from "components/shared/Beacon";
import Store from 'state/Store';
import {
  INCLUDED_ACCOUNTS,
  selectHistoricalTransactionIncludedAccountsV2,
  selectHistoricalTransactionTimePeriodV2,
  selectHistoricalTransactionTransactionTypeV2,
  TIME_PERIOD,
  TRANSACTION_TYPE
} from "state/transaction/TransactionActions";
import {isEmpty} from "lodash";
const TransactionHistoryFiltersV2 = ({
                                   filterOptions = {}
                                 }) => {
  // Set up event listeners for the filtering options to capture selection changes
  useEffect(() => {
    if (!isEmpty(filterOptions)) {
      const transactionHistoryIncludedAccounts = document.getElementById("transaction-history-included-accounts");
      transactionHistoryIncludedAccounts?.addEventListener("input", (event) => {
        Store.dispatch(
          selectHistoricalTransactionIncludedAccountsV2(event.target.value)
        );
      });
      const transactionHistoryTimePeriod = document.getElementById("transaction-history-time-period");
      transactionHistoryTimePeriod?.addEventListener("input", (event) => {
        Store.dispatch(
          selectHistoricalTransactionTimePeriodV2(event.target.value)
        );
      });
      const transactionHistoryTransactionType = document.getElementById("transaction-history-transaction-type");
      transactionHistoryTransactionType?.addEventListener("input", (event) => {
        Store.dispatch(
          selectHistoricalTransactionTransactionTypeV2(event.target.value)
        );
      });
    }
  }, [])

  return (
    <Fragment>
      <div className='b-grid'>
        <div className='b-grid-item--4-col'>
          <AAMBeaconControl>
            <label slot="label" htmlFor="transaction-history-time-period">
              Time period
            </label>
              <select id="transaction-history-time-period" name="transaction-history-time-period" aria-invalid="false" aria-disabled="false" className='b-grid'>
                {filterOptions[TIME_PERIOD].options.map((option, i) => {
                  return <option key={i} value={option?.value}>{option?.label}</option>
                })}
              </select>
          </AAMBeaconControl>
        </div>
        <div className='b-grid-item--4-col'>
          <AAMBeaconControl>
            <label slot="label" htmlFor="transaction-history-transaction-type">
              Transaction type
            </label>
            <select id="transaction-history-transaction-type" name="transaction-history-transaction-type" aria-invalid="false" aria-disabled="false">
              {filterOptions[TRANSACTION_TYPE].options.map((option, i) => {
                return <option key={i} value={option?.value}>{option?.label}</option>
              })}
            </select>
          </AAMBeaconControl>
        </div>
        <div className='b-grid-item--4-col'>
          <AAMBeaconControl>
            <label slot="label" htmlFor="transaction-history-included-accounts">
              Included accounts
            </label>
            <select id="transaction-history-included-accounts" name="transaction-history-included-accounts" aria-invalid="false" aria-disabled="false">
              {filterOptions[INCLUDED_ACCOUNTS].options.map((option, i) => {
                return <option key={i} value={option?.value}>{option?.label}</option>
              })}
            </select>
          </AAMBeaconControl>
        </div>
      </div>
    </Fragment>
  );
};

export default TransactionHistoryFiltersV2;
